export enum MessageTypes {
  // Am I a cloned tab?
  AM_I_CLONED = 'am-i-cloned',
  // Yes, you are a cloned tab
  YOU_ARE_CLONED = 'you-are-cloned',
  CLONE_UNLINKED = 'unlinked',
  TOKEN = 'token',
}
